import React from 'react';
import StatusBanner from '../common/StatusBanner';
import { Link } from 'react-router-dom';

class FluConsentConfirmation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { successMessage, failureMessage } = this.props;
        const confirmBtns = (
            <div className="row submit-consent-container navigation-btns-wrapper">
                <div className="col-12 navigation-btns">
                    {successMessage && (<a className="btn btn-primary" href="https://www.bswconnect.com/flu" target="_blank">LEARN MORE</a>)}
                    <Link className="btn btn-primary" to={'/'}>BACK TO DASHBOARD</Link>
                </div>
            </div>
        )

        return (
            <div className="row">
                <div className="col-12 flu-status-container">
                    {successMessage && <StatusBanner bannerMsg="Thanks, you're all set!" children={confirmBtns} />}
                    {failureMessage && <StatusBanner bannerMsg={failureMessage} subBannerMsg="Please try again later." children={confirmBtns} failedStatus />}
                </div>
            </div>
        );
    }
}

export default FluConsentConfirmation;